import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VModal from 'vue-js-modal'
import VueCookie from 'vue-cookie'

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

const isProdEnv = function () {
  return !(document.location.hostname.search(/(localhost)|(mm-dev3)|(st1-mm)|(numberly)/) > -1)
}

if (isProdEnv()) {
  Sentry.init({
    dsn: "https://fc5e35e2d284409a90ef934c2c5db1f1@sentry.numberly.net/156",
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
      }),
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1,
  });
}

Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.use(VModal, { dynamic: true })

import ApolloClient from "apollo-client";
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueApollo from "vue-apollo";
import 'isomorphic-unfetch'

var url = process.env.VUE_APP_API_URL

const httpLink = createHttpLink({
  uri: url,
  credentials: 'same-origin'
});

const client = new ApolloClient({
  link: httpLink,
  fetchOptions: { fetch },
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only'
    }
  }
});


import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)

import en from 'vee-validate/dist/locale/en.json'
import { email, required } from 'vee-validate/dist/rules'
import { ValidationObserver, localize, extend } from 'vee-validate'

const rules = {
  'email': email,
  'required': required,
  'validPassword': {
    validate: (value) => {
      return value.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)
    },
    message:
      'Le mot de passe n\'est pas valide.'
  }
}

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
Vue.component('ValidationObserver', ValidationObserver)
localize('en', en)

const apolloProvider = new VueApollo({
  defaultClient: client
});

Vue.use(VueApollo);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')
